import { useContext } from 'react'

import { RrwebClientContext } from '@core/rrweb/contexts/RrwebClientContext'

/** @returns rrweb client from the context. */
export const useRrwebClientContext = () => {
  return useContext(RrwebClientContext)
}
